import 'setimmediate' // https://github.com/necolas/react-native-web/issues/1891#issuecomment-887502705
import 'react-native-gesture-handler'
import * as SplashScreen from 'expo-splash-screen'
// Avoid issues with circular dependencies by initializing the store first.
import 'APP/Store'
import { registerRootComponent } from 'expo'
import { initNetworkLogging } from 'APP/Lib/Initializers'

import App from 'APP/Containers/App'
import { initializeNotifications } from 'APP/Lib/NotificationHelpers'
import { configureReanimatedLogger, ReanimatedLogLevel } from 'react-native-reanimated'
import { isEmbeddedEnvironment } from 'APP/BrownfieldBridge/utils'
import { startBrownfield } from 'APP/Services/Brownfield'

SplashScreen.preventAutoHideAsync()

configureReanimatedLogger({
  level: ReanimatedLogLevel.warn,
  strict: false,
})

// Init before app loads
initNetworkLogging()

initializeNotifications()

// It also ensures that whether you load the app in the Expo client or in a native build,
// the environment is set up appropriately
registerRootComponent(App)

/**
 * When the app is embedded mode, we want to perform additional operations
 * To perform some operations in the background before the main app is loaded
 */
if (isEmbeddedEnvironment()) {
  startBrownfield()
}
